/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Popover, OverlayTrigger, Row, Col, Checkbox} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import { connect } from 'react-redux';

const nodeTypes = [{name: "Host", id: "host"},
    {name: "All", id: "all"},
    {name: "None", id: "none"}];

var IPAddressDialog = React.createClass({
    getInitialState() {
        return {
            nodeTypes: "host",
            ipv4: "",
            ipv4Error: ipv4Validator(null),
            ipFlag: true,
            mac: "",
            macError: macValidator(null),
            macFlag: true
        };
    },

    helpPopover(){
        let addressErrorP = [];
        if (this.state.ipv4Error && this.state.ipFlag) {
            addressErrorP.push(<p key="ipError">{this.state.ipv4Error}</p>);
        }
        if (this.state.macError && this.state.macFlag) {
            addressErrorP.push(<p key="macError">{this.state.macError}</p>);
        }
        return (<Popover id="IPAddressHelpPopover" title="IP/MAC Address Help">
            <p>This command allows you to assign IP/MAC addresses to nodes based on a specified starting
                IPv4/MAC address. If <em>none</em> is selected IPv4/MAC addresses will be removed
                from all nodes.</p>
            {addressErrorP}
        </Popover>)
    },

    ipv4Change(e) {
        let newIpv4 = e.target.value;
        this.setState(Object.assign({}, this.state, {
            ipv4: newIpv4,
            ipv4Error: ipv4Validator(newIpv4)
        }));
    },

    ipv4Status() {
        if (this.state.ipv4Error && this.state.ipFlag) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    nodeTypeChange(e) {
        this.setState(Object.assign({}, this.state, {nodeTypes: e.target.value}));
    },

    applyHandler() {
        if (this.addressError()) {
            return;
        }
        let newNet = null;
        if (this.state.ipFlag) {
            newNet = assignIPs(this.state.ipv4, this.state.nodeTypes, this.props.net);
        }
        if (this.state.macFlag) {
            if (newNet) {
                newNet = assignMACs(this.state.mac, this.state.nodeTypes, newNet);
            } else {
                newNet = assignMACs(this.state.mac, this.state.nodeTypes, this.props.net);
            }
        }
        this.props.updateIPv4Address(newNet);
    },

    addressError() {
        if (this.state.nodeTypes === 'none') {
            return false;
        } else {
            return (this.state.ipFlag && Boolean(this.state.ipv4Error)) ||
                (this.state.macFlag && Boolean(this.state.macError));
        }

    },

    ipSelectChange() {
        this.setState(Object.assign({}, this.state, {ipFlag: !this.state.ipFlag}));
    },

    macSelectChange() {
        this.setState(Object.assign({}, this.state, {macFlag: !this.state.macFlag}));
    },

    macChange(e) {
        let newMac = e.target.value;
        this.setState(Object.assign({}, this.state, {
            mac: newMac,
            macError: macValidator(newMac)
        }));

    },

    macStatus() {
        if (this.state.macError && this.state.macFlag) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    render(){
        let nodeTypeOptions = nodeTypes.map(function (ntype) {
            return <option value={ntype.id}
                           key={"nType-" + ntype.id}>{ntype.name}</option>;
        });
        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="ipv4-addr-modal"
               dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} >
            <Modal.Header closeButton>
                <Modal.Title>IPv4/MAC Address Assignment</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                <form className="form-horizontal">

                            <Row>
                                <Col xs={7} >
                                    <label
                                        className="control-label">Which Nodes?</label>
                                </Col>
                                <Col xs={5}>
                                    <select value={this.state.nodeTypes}
                                            className="form-control"
                                            onChange={this.nodeTypeChange}>
                                        {nodeTypeOptions}
                                    </select>
                                </Col>
                            </Row>
                            <p></p>
                            <Row>
                                <div className={this.ipv4Status()}>
                                <Col xs={7} >
                                    <Checkbox checked={this.state.ipFlag } onChange={this.ipSelectChange}> IPv4 Addresses (start)</Checkbox>
                                </Col>
                                <Col xs={5}>
                                    <input type="text"
                                           value={this.state.ipv4}
                                           className="form-control" onChange={this.ipv4Change}/>
                                </Col></div>
                            </Row>
                                                <Row>
                                <div className={this.macStatus()}>
                                <Col xs={7} >
                                    <Checkbox checked={this.state.macFlag } onChange={this.macSelectChange}> MAC Addresses (start)</Checkbox>
                                </Col>
                                <Col xs={5}>
                                    <input type="text"
                                           value={this.state.mac}
                                           className="form-control" onChange={this.macChange}/>
                                </Col></div>
                            </Row>
                    </form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary"
                            onClick={this.applyHandler} disabled={this.addressError()}>Add </Button>
                <Button onClick={this.props.close} >Close</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});

function ipv4Validator(ipv4) {
    let ipv4Reg = /^(([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)\.){3}([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)$/;
    if (!ipv4Reg.test(ipv4)) {
        return "Bad IPv4 address";
    }
}

function macValidator(mac) {
    // RegEx for Ethernet address validation check
    let ethReg = /^[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}$/;
    if (!ethReg.test(mac)) {
        return ("Bad Ethernet address");
    }
}

function assignIPs(ipString, whichNodes, net) {
    // Make an array containing a copy of every node
    let nodes = net.nodes.map((n) => Object.assign({}, n));
    let ipAddr = ipStringToInt(ipString);
    for (let node of nodes) {
        delete node.ipv4;
        if (whichNodes === "all") {
            node.ipv4 = ipIntToString(ipAddr);
            ipAddr++;
        } else if (node.type === "host" && whichNodes === "host") {
            node.ipv4 = ipIntToString(ipAddr);
            ipAddr++;
        }
    }
    return Object.assign({}, net, {nodes: nodes});
}

function ipStringToInt(ipString) {
    let numStrings = ipString.split(".");
    let ipInt = 0;
    ipInt |= parseInt(numStrings[0]) << 24;
    ipInt |= parseInt(numStrings[1]) << 16;
    ipInt |= parseInt(numStrings[2]) << 8;
    ipInt |= parseInt(numStrings[3]);
    return ipInt;
}

function ipIntToString(ipInt) {
    let numStrings = [];
    numStrings.push(((ipInt & 0xFF000000) >>> 24).toString());
    numStrings.push(((ipInt & 0x00FF0000) >>> 16).toString());
    numStrings.push(((ipInt & 0x0000FF00) >>> 8).toString());
    numStrings.push(((ipInt & 0x000000FF)).toString());
    return numStrings.join(".");
}

function assignMACs(macString, whichNodes, net) {
    // Make an array containing a copy of every node
    let nodes = net.nodes.map((n) => Object.assign({}, n));
    let macAddr = macStringToInt(macString);
    for (let node of nodes) {
        delete node.mac;
        if (whichNodes === "all") {
            node.mac = macIntToString(macAddr);
            macAddr++;
        } else if (node.type === "host" && whichNodes === "host") {
            node.mac = macIntToString(macAddr);
            macAddr++;
        }
    }
    return Object.assign({}, net, {nodes: nodes});
}

function macStringToInt(macString) {
    let numStrings = macString.split(":");
    let macInt = 0;
    macInt += parseInt(numStrings[0], 16)*Math.pow(16, 10);
    macInt += parseInt(numStrings[1], 16)*Math.pow(16, 8);
    macInt += parseInt(numStrings[2], 16)*Math.pow(16, 6);
    macInt += parseInt(numStrings[3], 16)*Math.pow(16, 4);
    macInt += parseInt(numStrings[4], 16)*Math.pow(16, 2);
    macInt += parseInt(numStrings[5], 16);
    return macInt;
}

function macIntToString(macInt) {
    let temp = macInt;
    let numStrings = [];
    for (let i=10; i >= 0; i = i - 2) {
        let factor = Math.floor(temp/Math.pow(16, i));
        temp -= factor*Math.pow(16, i);
        let fstring = factor.toString(16);
        if (fstring.length < 2) {
            fstring = "0" + fstring;
        }
        numStrings.push(fstring);
    }
    return numStrings.join(":").toUpperCase();
}

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showIPAddressModal,
        net: state.net
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_IP_ADDRESS_DIALOG'});
        },
        updateIPv4Address: (net) => {
            dispatch({type: 'IPV4_ADDRESS_UPDATE', net: net});
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IPAddressDialog)




// WEBPACK FOOTER //
// ./src/netManip/IPAddressDialog.js